import { render, staticRenderFns } from "./ReviewReply.vue?vue&type=template&id=d527fd46&scoped=true&"
import script from "./ReviewReply.vue?vue&type=script&lang=js&"
export * from "./ReviewReply.vue?vue&type=script&lang=js&"
import style0 from "./ReviewReply.vue?vue&type=style&index=0&id=d527fd46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d527fd46",
  null
  
)

export default component.exports